export default __webpack_public_path__ + "static/media/Umea.090aa4a4.png";